import { createSelector } from 'reselect'
import { convertUTC } from '../functions/text_format'

export const orderedRecords = createSelector(
  (state) => state.records.get('records'),
  (records) =>
    records.sortBy((record) => convertUTC(record.get('recordDate'))).reverse()
)
